<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="setting.prod_name" ttReadonly></tt-input>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
